import { KAPLAYCtx } from "kaplay";
import { NPC, PHYSICS } from "./constants";
import { getTerrainSlope, getTerrainY } from "./terrain";
import type { NPC as NPCType, TerrainPoint, TrailPoint } from "./types";

export function updateNPC(
  npc: NPCType,
  terrain: TerrainPoint[],
  dt: number,
  npcSpeed: number,
  verticalOffset = 0,
  customNpcRadius: number = NPC.RADIUS,
): void {
  npc.vx = npcSpeed;

  npc.x += npc.vx * PHYSICS.PTM_RATIO * dt;

  const terrainY = getTerrainY(npc.x, terrain);
  npc.y = terrainY - customNpcRadius * PHYSICS.PTM_RATIO;
  npc.onGround = true;

  const slope = getTerrainSlope(npc.x, terrain);
  npc.angle = Math.atan(slope);

  npc.vy = npc.vx * slope;

  updateNPCTrail(npc, verticalOffset);
}

export function updateNPCTrail(npc: NPCType, verticalOffset = 0): void {
  npc.trail.push({ x: npc.x, y: npc.y + verticalOffset, alpha: 1.0 });

  if (npc.trail.length > NPC.TRAIL_LENGTH) {
    npc.trail.shift();
  }

  for (const [index, point] of npc.trail.entries()) {
    point.alpha = index / npc.trail.length;
  }
}

export function renderNpcTrail(
  k: KAPLAYCtx,
  trail: TrailPoint[],
  customNpcRadius: number = NPC.RADIUS,
): void {
  const npcPixelRadius = customNpcRadius * PHYSICS.PTM_RATIO;
  const spriteSize = npcPixelRadius * 2;

  for (let i = 0; i < trail.length - 1; i++) {
    const current = trail[i];
    const next = trail[i + 1];

    k.drawLine({
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      p1: k.vec2(current.x, current.y),
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      p2: k.vec2(next.x, next.y),
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      width: (spriteSize / 2) * current.alpha,
      color: k.rgb(255, 255, 255),
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      opacity: current.alpha * 0.7,
    });
  }
}
